import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Game} from "../../interfaces/game";
import {GamesService} from "../../services/games.service";
import {ItemTag} from "../../interfaces/item-tag";
import {LargeMessageService} from "../../services/large-message.service";
import {AnimationItem} from "lottie-web";

@Component({
  selector: 'brt-game-preview',
  templateUrl: './game-preview.component.html',
  styleUrls: ['./game-preview.component.scss']
})
export class GamePreviewComponent implements OnInit, OnDestroy {
  @Input('data') set setData(val: Game) {
    this.data = val;

    this.nameItemTag.setTitle(this.data.name);
    this.propertyTags = this.gamesService.gamePropertiesToItemTags(this.data);
  }
  data!: Game;
  propertyTags: ItemTag[] = [];

  currentOnlineInterval = -1;
  private readonly DELAY_BETWEEN_ONLINE_REQUEST = 10000;

  currentOnline = 0;

  nameItemTag: ItemTag = new ItemTag().setSize("small").setColor("game-blue");

  constructor(private gamesService: GamesService,
              private largeMessageService: LargeMessageService) {
  }

  ngOnInit() {

    // online requests
    this.gamesService.getGameCurrentOnline(this.data.id).then((online) => {
      this.data.currentOnline = online;
      this.propertyTags = this.gamesService.gamePropertiesToItemTags(this.data);
    });

    this.currentOnlineInterval = window.setInterval(async () => {
      this.gamesService.getGameCurrentOnline(this.data.id).then((online) => {
        this.data.currentOnline = online;

        this.propertyTags = this.gamesService.gamePropertiesToItemTags(this.data);
      });

    }, this.DELAY_BETWEEN_ONLINE_REQUEST);
    //
  }

  ngOnDestroy() {
    clearInterval(this.currentOnlineInterval);
  }

  onStartClick() {
    if(this.data.properties.isAvailable) {
      this.gamesService.startGameSetup(this.data.id);
      // this.largeMessageService.showLargeMessage(this.gamesService.getLargeMessageOnStartByGameId(this.data.id));
    }
  }

  onLottieInstanceCreated($event: AnimationItem) {
    if(!this.data.properties.isAvailable) {
      $event.stop();
    }
  }
}
